import React from "react"
import Contact from "../shared/top/Contact"

const TopContact = () => {
  return <Contact target="noone" tel="048-598-4023" />
}

export default TopContact
